module.exports = __webpack_public_path__ + "img/l-xiaotuiwei-nv.6a3b3d68.jpg";